/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 */

import type { Prng } from '@dicebear/core';
import type { Options, ComponentPickCollection } from '../types.js';
import { pickComponent } from './pickComponent.js';

type Props = {
  prng: Prng;
  options: Options;
};

export function getComponents({ prng, options }: Props): ComponentPickCollection {
  const goon1Component = pickComponent({
    prng,
    group: 'goon1',
    values: options.goon1,
  });
  const wave1Component = pickComponent({
    prng,
    group: 'wave1',
    values: options.wave1,
  });
  const wave2Component = pickComponent({
    prng,
    group: 'wave2',
    values: options.wave2,
  });
  const wave3Component = pickComponent({
    prng,
    group: 'wave3',
    values: options.wave3,
  });

  return {
    goon1: goon1Component,
    wave1: wave1Component,
    wave2: wave2Component,
    wave3: wave3Component,
  };
}
